import { FileDetailQueryResponseType } from '@/modules/FileList/queries/fileDetail/fileDetailQuery.type.ts';
import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import convertTimeStampToDate from '@/common/utils/convertTimeStampToDate.ts';

export const fileDetailItemsGenerator = (
  data: FileDetailQueryResponseType,
): DetailCardItemData[] => [
  {
    type: 'default',
    keyName: 'شناسه پرونده',
    value: data.order_id,
    dirLtr: true,
  },
  {
    type: 'tel',
    telephone: data.applicant_user_phone_number,
    keyName: data.file_type.const === 'property' ? 'اعلام کننده' : 'بیمه گذار',
    value: data.applicant_user_full_name,
  },
  {
    type: 'default',
    keyName: data.file_type.const === 'property' ? 'بیمه‌گر (مقصر)' : 'بیمه‌گر',
    value: data.insurance?.fa_const,
  },
  {
    type: 'default',
    keyName: 'زمان وقوع',
    value:
      data.event_happening_date && data.event_happening_time
        ? `${data.event_happening_time} ${convertTimeStampToDate(
            data.event_happening_date,
            {
              hour: undefined,
              minute: undefined,
            },
          )}`
        : undefined,
  },
  {
    type: 'default',
    keyName: 'تاریخ تشکیل',
    value: convertTimeStampToDate(data.creation_date!, {
      hour: undefined,
      minute: undefined,
    }),
  },
  {
    type: 'default',
    keyName: 'تاریخ قرارگیری در وضعیت',
    value: data.action_date,
  },
  {
    type: 'default',
    keyName: 'وضعیت پرونده',
    value: data.status.fa_const,
  },
  {
    type: 'default',
    keyName: 'آدرس بازدید',
    value: data.visit_location,
  },
];
